module.exports = __webpack_public_path__ + "img/redIncident.b15e80d4.svg";